var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterSelected({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    id: "Filter-2--Streamline-Core.svg",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Filter 2 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "filter-2--funnel-filter-angle-oil"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fill: "#000000",
    fillRule: "evenodd",
    d: "M0.8571428571428571 0C0.5360674285714285 0 0.2419165714285714 0.17944114285714285 0.09499919999999999 0.4649297142857142 -0.05191885714285714 0.75042 -0.026964 1.0940777142857143 0.15965708571428572 1.355346857142857L8.571428571428571 13.131822857142858V23.142857142857142c0 0.31611428571428574 0.17398285714285713 0.6065142857142857 0.4526914285714286 0.7556571428571428 0.2787085714285714 0.14914285714285713 0.6168857142857143 0.13285714285714284 0.8799085714285713 -0.04251428571428571l5.142857142857142 -3.4285714285714284C15.285342857142854 20.268514285714286 15.428571428571427 20.000914285714284 15.428571428571427 19.71428571428571V13.131822857142858L23.8404 1.355346857142857c0.1865142857142857 -0.2612691428571428 0.21154285714285712 -0.6049268571428571 0.06462857142857142 -0.8904171428571429C23.758114285714285 0.17944114285714285 23.463942857142857 0 23.142857142857142 0H0.8571428571428571Z",
    clipRule: "evenodd",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterSelected);
export default __webpack_public_path__ + "static/media/Filter-selected.4b041b7c565ae396afbac9b971bebaf3.svg";
export { ForwardRef as ReactComponent };